const el = document.createElement('p');

export const decodeEntities = (string: string): string => {
  el.innerHTML = string;

  return el.textContent || el.innerText;
};
